import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Image } from 'react-bootstrap';
import { all, chat, facebook, linkedin, twitter, mail } from '../../Images/Images';
import { WINDOW_AT_500 } from '../../constants.js';
import { Singleton } from '../../js/Singleton';

class unifiedMessaging extends Component{
  constructor(props){
    super(props);
    this.state = {
      showAt500 : false
    }
    this.language = new Singleton();
    this.objMessages = [];
    this.objMessages.push({image: all, title: this.language.getText('multimediaModetitleAll'), number : 99});
    this.objMessages.push({image: chat, title:this.language.getText('multimediaModechatTitle'), number : 99});
    this.objMessages.push({image: facebook, title: this.language.getText('multimediaModefacebookTitle'), number : 99});
    this.objMessages.push({image: linkedin, title: this.language.getText('multimediaModelinkedinTitle'), number : 99});
    this.objMessages.push({image: twitter, title:this.language.getText('multimediaModetwitterTitle'), number : 99});
    this.objMessages.push({image: mail, title:this.language.getText('multimediaModeemailTitle'), number : 99});
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.windowVisible500.windowVisible === WINDOW_AT_500.MESSAGE){
      this.setState({showAt500:true});
    }else{
      this.setState({showAt500:false});
    }
  }

  renderMessagesObject(){
    var objectsMessage = [];
    for(let i in this.objMessages){
      objectsMessage.push(
        <div className="objectsUnifiedMessage" key={"not" + i}>
          <Image className="imageUnifiedMessage" src={this.objMessages[i].image}/>
          <p className="titleUnifiedMessage">{this.objMessages[i].title}</p>
          <p className="numberUnifiedMessage">{this.objMessages[i].number}</p>
        </div>
      );
    }
    return objectsMessage;
  }

  render() {
    return (
      <div className={this.state.showAt500 ?"UnifiedMessaging showMessage500":"UnifiedMessaging hidenMessage500"}>
        <div className="messageContainer">
          {this.renderMessagesObject()}
        </div>
      </div>
    );
  }
};


function mapStateToProps(state) {
  return {
    windowVisible500: state.windowVisible500
  }
}

export default unifiedMessaging = connect(
  mapStateToProps,
  null
)(unifiedMessaging);



// WEBPACK FOOTER //
// ./src/components/workSpace/unifiedMessaging.jsx